// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1RIbA","notes":"Notes_notes__3dZO9","note":"Notes_note__3sKfO","markdown":"Notes_markdown__3PIyo"};